<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNetProfitPerNetHaRev',
    extends: TableRowBase,
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'net_profit', throughMonth),
          this.getYtdByField(yearObj, 'gross_revenue', throughMonth),
        );
      },
    },
  };
</script>
